import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { containerStyle } from "../../styles/styles";
import { TableStyles } from "../../styles/table";
import VerticalTabs from "../../tabs";
import TabPanel from "../../common/TabPanel";
import LocalBarIcon from "@material-ui/icons/LocalBar";
import ActiveTab from "../../uis/enroleeTables/activeTable";
import PendingTab from "../../uis/enroleeTables/pendingTable";
import NonEnrolees from "../../uis/enroleeTables/nonenroleeTable";
import DeclinedEnrolees from "../../uis/enroleeTables/declinedEnroleesTable";

const tabLabels = ["Approved", "Pending", "Non-Enrollee", "Declined-Enrollee"];
const Enrollees = () => {
  const classes = containerStyle();
  const tabClasses = TableStyles();
  const history = useHistory();
  const { activetab } = useParams();

  const tabNameToIndex = {
    0: "approved",
    1: "pending",
    2: "non-enrollee",
    3: "declined-enrollee",
  };

  const indexToTabName = {
    approved: 0,
    pending: 1,
    "non-enrollee": 2,
    "declined-enrollee": 3,
  };

  const [tabIndex, setTabIndex] = useState(indexToTabName[activetab]);
  const onChangeTabIndex = (e, newValue) => {
    console.log(newValue);
    history.push(`/hmo/dashboard/enrollees/${tabNameToIndex[newValue]}`);
    setTabIndex(newValue);
  };

  return (
    <>
      <div className={tabClasses.filterContainer}>
        <p>
          <LocalBarIcon /> Filter by:
        </p>
      </div>
      <div className={classes.main}>
        <div className={tabClasses.tableRoot}>
          <div className={tabClasses.tabsSection}>
            <VerticalTabs
              tabData={tabLabels}
              tabIndex={tabIndex}
              onTabChange={onChangeTabIndex}
            />
          </div>
          <div className={tabClasses.tabPanelContainer}>
            <TabPanel value={0} index={tabIndex}>
              <ActiveTab />
            </TabPanel>
            <TabPanel value={1} index={tabIndex}>
              <PendingTab />
            </TabPanel>
            <TabPanel value={2} index={tabIndex}>
              <NonEnrolees />
            </TabPanel>
            <TabPanel value={3} index={tabIndex}>
              <DeclinedEnrolees />
            </TabPanel>
          </div>
        </div>
      </div>
    </>
  );
};

export default Enrollees;
